module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido11.2461dbb3.svg";